import { FilterPageOrder } from '@core/services/http-params/model/api-http-params.model';
import { StateTagType } from '@shared/ui-components/state-tag/models/tag.model';

export type MyInvoicesListingItem = {
  invoiceNumber: string;
  societyName: string;
  societyId: string;
  societyCif: string;
  societyCompleteName: string;
  installationName: string;
  installationId: string;
  installationCups: string;
  issueDate: string;
  supplyStartDate: string;
  supplyEndDate: string;
  billingGroup: string;
  type: string;
  consumption: number;
  amount: number;
  invoiceStateDescription?: string;
  invoiceStateCode: InvoiceStatusCode;
  invoiceStateTag?: StateTagType;
  invoiceDocumentId: string;
  installationCupsName?: string;
};

export type MyInvoicesListingFilter = FilterPageOrder & {
  invoiceNumber?: string;
  societies?: string[];
  installations?: string[];
  startIssueDate?: Date;
  endIssueDate?: Date;
  state?: MyInvoicesListingStatusFilter;
};

export enum MyInvoicesListingStatusFilter {
  PAID = 'PAID',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
}

export enum InvoiceStatusCode {
  PENDING_PAYMENT = '1',
  PAID = '2',
  OVERDUE = '300000000',
  RETURNED = '300000001',
  PAID_INACTIVE = '300000004',
  REJECTED_INACTIVE = '300000005',
  PREPAID = '300000006',
  PENDING_STATUS_UPDATE = '300000007',
  CONTESTED = '300000009',
  RECTIFIED = '300000010',
  CANCELLED = '300000011',
  REJECTED = '300000002',
  PREPAID_INACTIVE = '300000003',
  RATIFIED = '300000008',
}

export enum InvoiceClaimLevel {
  N1 = '300000000',
  N2 = '300000001',
  N3 = '300000002',
}
